<template>
	<nk-wrapper v-if="context" spacing="lg">
		<section>
			<nk-title :id="`title-${titleId}`" tag="h1" size="2xl">
				{{ context.titel }}
			</nk-title>
			<div v-if="context.text" class="nk-cms-content" v-html="context.text" />
			<nk-nav :aria-labelledby="`title-${titleId}`">
				<nk-nav-item
					v-for="(verfahren, verfahrenIndex) in context.verfahren"
					:key="verfahrenIndex"
					:link="verfahren.detailURL"
				>
					{{ verfahren.titel }}
				</nk-nav-item>
			</nk-nav>
		</section>
	</nk-wrapper>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';
import {useCMS, updateBreadcrumb, useSEO} from '#nk/composables/cms';
import {useId} from '#imports';

export default {
	name: 'NkTemplateWegweiserLebenslageVerfahren',

	mixins: [TemplatesDefault],

	setup(ctx) {
		const page = useCMS();
		if (ctx.context.titel) {
			updateBreadcrumb({title: ctx.context.titel});
		}

		useSEO({
			title: ctx.context.seo?.title || ctx.context.titel,
			description: ctx.context.seo?.description || page.value.description,
		});

		const titleId = useId();
		return {titleId};
	},
};
</script>
